import { makeStyles } from '@material-ui/core/styles';
import { useProvider, useProviderFunctions } from '../../contexts/ProviderContext';
import happyFaceImage from '_assets/dashboard/happy-face.png';

const useStyles = makeStyles(() => ({
  input: {
    display: 'none',
  },
  image: {
    borderRadius: 40,
    cursor: 'pointer',
    marginTop: '20px',
  },
}));

const ProviderProfilePicture = () => {
  const classes = useStyles();
  const { profilePicture } = useProvider();
  const { editProfilePicture } = useProviderFunctions();

  const uploadImage = async (event) => {
    if (event.target.files !== null && event.target.files.length > 0) {
      const targetFile = event.currentTarget.files[0];
      const file = new Blob([targetFile], { type: "image/*" });
      let formData = new FormData();
      formData.append("file", targetFile);
      editProfilePicture(file, formData);
    }
  }

  return (
    <>
      <input
        accept="image/*"
        onChange={uploadImage}
        className={classes.input}
        id='providerProfilePictureInput'
        name='providerProfilePicture'
        type='file'
      />
      <label htmlFor='providerProfilePictureInput'>
        <img
          id='loadedProfilePicture'
          alt='user'
          className={classes.image}
          src={profilePicture ? profilePicture : happyFaceImage}
          width='80px'
          height='80px'
        />
      </label>
    </>
  );
};

export default ProviderProfilePicture;
